import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sm:col-span-1 flex flex-col"
}
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "relative mt-2 rounded-md shadow-sm" }
const _hoisted_4 = ["type", "name", "id", "placeholder"]
const _hoisted_5 = ["id"]
const _hoisted_6 = ["id"]
const _hoisted_7 = {
  key: 1,
  class: "sm:col-span-1"
}
const _hoisted_8 = {
  key: 2,
  class: "w-full"
}
const _hoisted_9 = { class: "relative w-full" }
const _hoisted_10 = ["id", "placeholder", "required", "disabled"]
const _hoisted_11 = ["id"]
const _hoisted_12 = { class: "relative z-50" }
const _hoisted_13 = ["id"]
const _hoisted_14 = ["id"]

import { ref, shallowRef, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { defineEmits } from "@vue/runtime-core";
import * as dtos from "@/models/dtos";
import { MainContainer } from "@/models/MainContainer";
import { Profile } from "@/models/Profile";

export default /*@__PURE__*/_defineComponent({
  __name: 'InputText2',
  props: {
  model: {
    required: false,
  },
  type: String,
  required: {
    type: Boolean,
    required: false,
    default: false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  adminView: {
    type: Boolean,
    required: false,
    default: false,
  },
  editMode: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["change"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const containerByDNS = ref<Profile>(null);
const emit = __emit;
const props = __props;

const showingErrorMessage = ref(false);

const showErrorMessage = () => {
  showingErrorMessage.value = true;
};
const hideErrorMessage = () => {
  showingErrorMessage.value = false;
};
let model = shallowRef(props.model as dtos.DynamicProperty);

function customChange() {
  emit("change", model.value);
}

onMounted(async () => {
  await store.dispatch("loadContainerTheme");
  try {
    await store.dispatch("loadContainerTheme");
    containerByDNS.value = new Profile(
      new MainContainer(store.getters.publicContainer)
    );
    // isLoaded.value = true;
  } catch (error) {
    console.error("Error loading public container:", error);
  }
});

const test = ref('#FF0000')
const themedText = computed(() => store.getters.getContainerThemedText);

return (_ctx: any,_cache: any) => {
  return (props.adminView && props.editMode)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", {
          style: _normalizeStyle({color: themedText.value?.otherText}),
          for: _unref(model).label,
          class: "text-sm font-medium text-gray-500"
        }, _toDisplayString(_unref(model).label || "fältet saknar rubrik"), 13, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            onInput: customChange,
            type: props.type || 'text',
            name: _unref(model).label,
            id: _unref(model).key,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).data) = $event)),
            class: "p-2 block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 focus:outline-none sm:text-sm sm:leading-6",
            placeholder: _unref(model).placeholder
          }, null, 40, _hoisted_4), [
            [_vModelDynamic, _unref(model).data]
          ]),
          _createElementVNode("div", {
            class: "hidden pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3",
            id: 'icon-error_' + _unref(model).key
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("i", {
              class: "fas fa-exclamation-circle text-red-500",
              "aria-hidden": "true"
            }, null, -1)
          ]), 8, _hoisted_5)
        ]),
        _createElementVNode("p", {
          id: 'error_' + _unref(model).key,
          class: "mt-2 text-sm text-red-600"
        }, null, 8, _hoisted_6)
      ]))
    : (props.adminView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("dt", {
            style: _normalizeStyle({color: themedText.value?.otherText}),
            class: "text-sm font-medium text-gray-500"
          }, _toDisplayString(_unref(model).label || "fältet saknar rubrik"), 5),
          _createElementVNode("dd", {
            style: _normalizeStyle({color: themedText.value?.otherText}),
            class: "mt-1 text-sm text-gray-900"
          }, _toDisplayString(_unref(model).data || "Ingen information angiven."), 5)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("label", {
            style: _normalizeStyle({color: themedText.value?.otherText}),
            class: "block uppercase tracking-wide text-darkGray-1 text-xs font-bold mb-1",
            for: "name"
          }, _toDisplayString(_unref(model).label), 5),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              onInput: customChange,
              class: "appearance-none block w-full bg-blue-4 text-darkGray-1 placeholder-darkGray-4 border border-blue-4 rounded py-1 sm:py-3 px-4 leading-tight focus:bg-white focus:border-blue-1 disabled:bg-gray-2 disabled:text-darkGray-2 disabled:cursor-not-allowed relative",
              id: _unref(model).key,
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).data) = $event)),
              placeholder: _unref(model).placeholder,
              required: props.required ? true : null,
              disabled: props.disabled ? true : null
            }, null, 40, _hoisted_10), [
              [_vModelText, _unref(model).data]
            ]),
            _createElementVNode("div", {
              id: 'icon-error_' + _unref(model).key,
              class: "hidden absolute top-0 bottom-0 right-0 left-auto w-[60px] flex flex-row justify-center items-center",
              onMouseenter: showErrorMessage,
              onMouseleave: hideErrorMessage
            }, _cache[3] || (_cache[3] = [
              _createElementVNode("i", { class: "text-red-2 fa-solid fa-circle-info" }, null, -1)
            ]), 40, _hoisted_11)
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              class: "absolute top-0 left-0 right-0 bottom-auto bg-white rounded-md p-2 shadow-md",
              id: 'outer-error_' + _unref(model).key
            }, [
              _createElementVNode("p", {
                class: "font-medium text-sm text-red-2",
                id: 'error_' + _unref(model).key
              }, null, 8, _hoisted_14)
            ], 8, _hoisted_13)
          ], 512), [
            [_vShow, showingErrorMessage.value]
          ])
        ]))
}
}

})